import { ShieldCheck, Clock, MapPin, Award, Star, Users } from "lucide-react";

const TRUST_ITEMS = [
  {
    icon: Users,
    text: "Conseil personnalisé",
    description: "Accompagnement de A à Z"
  },
  {
    icon: Star,
    text: "4.9/5 Google",
    description: "91 avis clients"
  },
  {
    icon: Clock,
    text: "Urgence 24h",
    description: "Intervention rapide"
  },
  {
    icon: Award,
    text: "Primes Wallonie",
    description: "On gère vos démarches"
  }
];

const TrustBar = () => {
  return (
    <section id="trust" className="py-12 bg-white border-b border-slate-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {TRUST_ITEMS.map((item, index) => (
            <div 
              key={index}
              className="flex flex-col items-center text-center p-4 animate-fade-in"
              style={{ animationDelay: `${index * 0.1}s` }}
              data-testid={`trust-item-${index}`}
            >
              <div className="w-14 h-14 bg-amber-50 rounded-2xl flex items-center justify-center mb-4">
                <item.icon className="w-7 h-7 text-amber-600" />
              </div>
              <h3 className="font-heading font-semibold text-slate-900 mb-1">
                {item.text}
              </h3>
              <p className="text-sm text-slate-500">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustBar;
